import React from 'react';
import Avatar from '@material-ui/core/Avatar';
import CircularProgress from '@material-ui/core/CircularProgress';
import FormHelperText from '@material-ui/core/FormHelperText';
import PictureModel from '../../models/PictureModel';
import './PictureInput.css';

export default class extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            id: (new Date().getTime() + Math.floor((Math.random()*10000)+1)).toString(16),
            placeholderPicture: this.props.placeholderPicture || null,
            uploading: false,
            error: null
        };
    }

    componentDidUpdate() {
        if (this.props.placeholderPicture !== undefined && this.props.placeholderPicture !== this.state.placeholderPicture) {
            this.setState({ placeholderPicture: this.props.placeholderPicture });
        }
    }

    handleChange = async (event) => {
        const input = event.target;

        if (input.files && input.files[0]) {
            const file = input.files[0];

            this.setState({
                uploading: true,
                error: null
            });

            try {
                const { url, filename, headers } = await PictureModel.allow(file.name.substring(file.name.lastIndexOf('.') + 1));

                await PictureModel.remoteUpload(url, file, headers);
                const {id, displayPath} = await PictureModel.createAfterRemoteUpload(filename);

                this.setState({
                    file,
                    placeholderPicture: displayPath
                });

                this.props.onChange({ id, displayPath });
            } catch (error) {
                this.setState({ error: error.message || 'Unable to upload the image. Please try again.' });
            } finally {
                input.value = '';
                this.setState({ uploading: false });
            }
        } else {
            this.setState({ file: null });
        }
    };

    render() {
        return <div className="PictureInput" style={{width: '100%', textAlign: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center'}}>
            <input
                id={this.state.id}
                style={{
                    width: '0.1px',
                    height: '0.1px',
                }}
                type="file"
                name="pictureFile"
                disabled={this.state.uploading}
                onChange={this.handleChange}
            />
            <label
                htmlFor={this.state.id}
            >
                <Avatar
                    src={!this.state.uploading ? this.state.placeholderPicture : null}
                    style={{width: '5rem', height: '5rem'}}
                >
                    { this.state.uploading ? <CircularProgress color="inherit" /> : this.props.label }
                </Avatar>
            </label>
            {this.state.error && <FormHelperText error role="alert">{this.state.error}</FormHelperText>}
        </div>;
    }
}
